import { createContext, useContext } from 'react'

type ModalContextType = {
  id: string
  onClose: () => void
}

export const ModalContext = createContext<ModalContextType | undefined>(
  undefined
)

export const useModalContext = () => useContext(ModalContext)
